import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_cell = _resolveComponent("van-cell");
  const _component_van_cell_group = _resolveComponent("van-cell-group");
  const _component_van_field = _resolveComponent("van-field");
  const _component_stand_countdown_cpt = _resolveComponent("stand-countdown-cpt");
  const _component_van_button = _resolveComponent("van-button");
  const _component_van_form = _resolveComponent("van-form");
  const _component_CustomerQueryCpt = _resolveComponent("CustomerQueryCpt");
  const _component_ValidateCodePageCpt = _resolveComponent("ValidateCodePageCpt");
  const _component_PageNavBackLayoutCpt = _resolveComponent("PageNavBackLayoutCpt");
  return _openBlock(), _createBlock(_component_PageNavBackLayoutCpt, {
    class: "page"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_cell_group, {
      title: "机构信息"
    }, {
      default: _withCtx(() => [_createVNode(_component_van_cell, {
        title: "理财顾问",
        value: $data.agent.agentName
      }, null, 8, ["value"])]),
      _: 1
    }), _createVNode(_component_van_cell_group, {
      title: "产品信息"
    }, {
      default: _withCtx(() => [_createVNode(_component_van_cell, {
        title: "产品名称",
        value: $data.production.productName
      }, null, 8, ["value"]), _createVNode(_component_van_cell, {
        title: "成立日",
        value: $data.production.foundDate
      }, null, 8, ["value"]), _createVNode(_component_van_cell, {
        title: "开放日",
        value: $data.production.openDate
      }, null, 8, ["value"]), _createVNode(_component_van_cell, {
        title: "封帐日",
        value: $data.production.raiseEndDate
      }, null, 8, ["value"]), _createVNode(_component_van_cell, {
        title: "风险等级",
        value: _ctx.formatSelectColumn($data.codeResItems, 'riskGrade', {
          riskGrade: $data.production.riskGrade
        })
      }, null, 8, ["value"])]),
      _: 1
    }), _createVNode(_component_van_cell_group, {
      title: "客户信息"
    }, {
      default: _withCtx(() => [_createVNode(_component_van_form, {
        onSubmit: $options.onSubmit
      }, {
        default: _withCtx(() => [_createVNode(_component_van_field, {
          modelValue: $data.customer.chnName,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.customer.chnName = $event),
          readonly: "",
          clickable: "",
          required: "",
          "right-icon": "search",
          name: "customerId",
          label: "客户姓名",
          placeholder: "客户姓名",
          rules: [{
            required: true,
            message: '请查询客户'
          }],
          onClick: $options.onSelectCustomerClick,
          onClickRightIcon: $options.onSelectCustomerClick
        }, null, 8, ["modelValue", "onClick", "onClickRightIcon"]), _createVNode(_component_van_field, {
          modelValue: $data.form.amount,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.form.amount = $event),
          required: "",
          name: "password",
          label: "预约额度(元)",
          placeholder: "预约额度(元)",
          rules: [{
            required: true,
            message: '请输入预约额度(元)'
          }]
        }, null, 8, ["modelValue", "rules"]), _createVNode(_component_stand_countdown_cpt, {
          onAcountDown: _cache[2] || (_cache[2] = $event => $options.autoReFresh()),
          times: $data.startTime,
          isShowCountDown: !this.canSubmit
        }, null, 8, ["times", "isShowCountDown"]), this.canSubmit ? (_openBlock(), _createBlock(_component_van_button, {
          key: 0,
          style: {
            "width": "100%"
          },
          type: "primary",
          "native-type": "submit",
          loading: $data.btnLoading
        }, {
          default: _withCtx(() => [_createTextVNode(" 提交申请 ")]),
          _: 1
        }, 8, ["loading"])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["onSubmit"])]),
      _: 1
    }), _createVNode(_component_CustomerQueryCpt, {
      ref: "CustomerQueryCpt",
      onSelected: $options.onCustomerSelected
    }, null, 8, ["onSelected"]), _createVNode(_component_ValidateCodePageCpt, {
      ref: "ValidateCodePageCpt",
      onSelected: $options.onConfirmCode
    }, null, 8, ["onSelected"])]),
    _: 1
  });
}